import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { MarkdownDirective } from '../markdown/markdown.directive';
import { AlertService, IAlert, IAlertButton } from '../../services/alert.service';

@Component({
  selector: 'ui-alert',
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss',
  imports: [MarkdownDirective],
  host: {
    'animate.enter': 'ui-alert-enter',
    'animate.leave': 'ui-alert-leave',
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertComponent {
  readonly data = input.required<IAlert>();
  private readonly alerts = inject(AlertService);

  onButtonClick(btn: IAlertButton, e: MouseEvent) {
    btn.click?.(btn, e);
    if (btn.close) {
      this.close();
    }
  }

  close() {
    this.alerts.close(this.data());
  }
}
